import { isMobile } from '../../../../core/helpers/isMobile';
import { ColumnsType } from '../../../../core/constants/columnsType';
import { popupStore } from '../../../../store/popupStore';
import { PopupTypes } from '../../../../core/constants/popupTypes';
import { checkHashStore } from '../../../../store/checkHashStore';
import { TranslationKeys } from '../../../../core/constants/translationKeys';
import { isPG, isTopC } from '../../../../core/helpers/skinHelper';
import { cryptoCurrencies } from '../../../../core/constants/cryptoCurrencies';
import { userInfoStore } from '../../../../store/userInfoStore';

export const KENO_RISK_TYPE = {
  Classic: 0,
  Low: 1,
  Medium: 2,
  High: 3,
};

export const KENO_RISK_TYPE_NAME = {
  0: 'classic',
  1: 'low',
  2: 'medium',
  3: 'high',
};

export const riskButtonConfigs = [
  {
    buttonType: KENO_RISK_TYPE.Classic,
    name: TranslationKeys.KenoClassic,
    color: 'purple',
  },
  {
    buttonType: KENO_RISK_TYPE.Low,
    name: TranslationKeys.KenoLow,
    color: 'green',
  },
  {
    buttonType: KENO_RISK_TYPE.Medium,
    name: TranslationKeys.KenoMedium,
    color: 'yellow',
  },
  {
    buttonType: KENO_RISK_TYPE.High,
    name: TranslationKeys.KenoHigh,
    color: 'red',
  },
];

export const KENO_NUMBERS_ANIMATION_DURATION = 2000;

export const KENO_NUMBERS_COUNT = 40;
export const NumbersType = {
  Self_1: 'Self_1',
  Right_1: 'Right_1',
  Bottom_1: 'Bottom_1',
  Center_1: 'Center_1',
  Self_2: 'Self_2',
  Right_2: 'Right_2',
  Bottom_2: 'Bottom_2',
  Center_2: 'Center_2',
  Self_3: 'Self_3',
  Right_3: 'Right_3',
  Bottom_3: 'Bottom_3',
  Center_3: 'Center_3',
  Self_4: 'Self_4',
  Right_4: 'Right_4',
  Bottom_4: 'Bottom_4',
  Center_4: 'Center_4',
  Self_5: 'Self_5',
  Right_5: 'Right_5',
  Bottom_5: 'Bottom_5',
  Center_5: 'Center_5',
  Self_6: 'Self_6',
  Right_6: 'Right_6',
  Bottom_6: 'Bottom_6',
  Center_6: 'Center_6',
  Self_7: 'Self_7',
  Right_7: 'Right_7',
  Bottom_7: 'Bottom_7',
  Center_7: 'Center_7',
  Self_8: 'Self_8',
  Right_8: 'Right_8',
  Bottom_8: 'Bottom_8',
  Center_8: 'Center_8',
  Self_9: 'Self_9',
  Right_9: 'Right_9',
  Bottom_9: 'Bottom_9',
  Center_9: 'Center_9',
  Self_10: 'Self_10',
  Right_10: 'Right_10',
  Bottom_10: 'Bottom_10',
  Center_10: 'Center_10',
  Self_11: 'Self_11',
  Right_11: 'Right_11',
  Bottom_11: 'Bottom_11',
  Center_11: 'Center_11',
  Self_12: 'Self_12',
  Right_12: 'Right_12',
  Bottom_12: 'Bottom_12',
  Center_12: 'Center_12',
  Self_13: 'Self_13',
  Right_13: 'Right_13',
  Bottom_13: 'Bottom_13',
  Center_13: 'Center_13',
  Self_14: 'Self_14',
  Right_14: 'Right_14',
  Bottom_14: 'Bottom_14',
  Center_14: 'Center_14',
  Self_15: 'Self_15',
  Right_15: 'Right_15',
  Bottom_15: 'Bottom_15',
  Center_15: 'Center_15',
  Self_16: 'Self_16',
  Right_16: 'Right_16',
  Bottom_16: 'Bottom_16',
  Center_16: 'Center_16',
  Self_17: 'Self_17',
  Right_17: 'Right_17',
  Bottom_17: 'Bottom_17',
  Center_17: 'Center_17',
  Self_18: 'Self_18',
  Right_18: 'Right_18',
  Bottom_18: 'Bottom_18',
  Center_18: 'Center_18',
  Self_19: 'Self_19',
  Right_19: 'Right_19',
  Bottom_19: 'Bottom_19',
  Center_19: 'Center_19',
  Self_20: 'Self_20',
  Right_20: 'Right_20',
  Bottom_20: 'Bottom_20',
  Center_20: 'Center_20',
  Self_21: 'Self_21',
  Right_21: 'Right_21',
  Bottom_21: 'Bottom_21',
  Center_21: 'Center_21',
  Self_22: 'Self_22',
  Right_22: 'Right_22',
  Bottom_22: 'Bottom_22',
  Center_22: 'Center_22',
  Self_23: 'Self_23',
  Right_23: 'Right_23',
  Bottom_23: 'Bottom_23',
  Center_23: 'Center_23',
  Self_24: 'Self_24',
  Right_24: 'Right_24',
  Bottom_24: 'Bottom_24',
  Center_24: 'Center_24',
  Self_25: 'Self_25',
  Right_25: 'Right_25',
  Bottom_25: 'Bottom_25',
  Center_25: 'Center_25',
  Self_26: 'Self_26',
  Right_26: 'Right_26',
  Bottom_26: 'Bottom_26',
  Center_26: 'Center_26',
  Self_27: 'Self_27',
  Right_27: 'Right_27',
  Bottom_27: 'Bottom_27',
  Center_27: 'Center_27',
  Self_28: 'Self_28',
  Right_28: 'Right_28',
  Bottom_28: 'Bottom_28',
  Center_28: 'Center_28',
  Self_29: 'Self_29',
  Right_29: 'Right_29',
  Bottom_29: 'Bottom_29',
  Center_29: 'Center_29',
  Self_30: 'Self_30',
  Right_30: 'Right_30',
  Bottom_30: 'Bottom_30',
  Center_30: 'Center_30',
  Self_31: 'Self_31',
  Right_31: 'Right_31',
  Bottom_31: 'Bottom_31',
  Center_31: 'Center_31',
  Self_32: 'Self_32',
  Right_32: 'Right_32',
  Bottom_32: 'Bottom_32',
  Center_32: 'Center_32',
  Self_33: 'Self_33',
  Right_33: 'Right_33',
  Bottom_33: 'Bottom_33',
  Center_33: 'Center_33',
  Self_34: 'Self_34',
  Right_34: 'Right_34',
  Bottom_34: 'Bottom_34',
  Center_34: 'Center_34',
  Self_35: 'Self_35',
  Right_35: 'Right_35',
  Bottom_35: 'Bottom_35',
  Center_35: 'Center_35',
  Self_36: 'Self_36',
  Right_36: 'Right_36',
  Bottom_36: 'Bottom_36',
  Center_36: 'Center_36',
  Self_37: 'Self_37',
  Right_37: 'Right_37',
  Bottom_37: 'Bottom_37',
  Center_37: 'Center_37',
  Self_38: 'Self_38',
  Right_38: 'Right_38',
  Bottom_38: 'Bottom_38',
  Center_38: 'Center_38',
  Self_39: 'Self_39',
  Right_39: 'Right_39',
  Bottom_39: 'Bottom_39',
  Center_39: 'Center_39',
  Self_40: 'Self_40',
  Right_40: 'Right_40',
  Bottom_40: 'Bottom_40',
  Center_40: 'Center_40',
};

export const kenoNumbers = [
  {
    number: 1,
    self: NumbersType.Self_1,
    right: NumbersType.Right_1,
    bottom: NumbersType.Bottom_1,
    center: NumbersType.Center_1,
  },
  {
    number: 2,
    self: NumbersType.Self_2,
    right: NumbersType.Right_2,
    bottom: NumbersType.Bottom_2,
    center: NumbersType.Center_2,
  },
  {
    number: 3,
    self: NumbersType.Self_3,
    right: NumbersType.Right_3,
    bottom: NumbersType.Bottom_3,
    center: NumbersType.Center_3,
  },
  {
    number: 4,
    self: NumbersType.Self_4,
    right: NumbersType.Right_4,
    bottom: NumbersType.Bottom_4,
    center: NumbersType.Center_4,
  },
  {
    number: 5,
    self: NumbersType.Self_5,
    right: NumbersType.Right_5,
    bottom: NumbersType.Bottom_5,
    center: NumbersType.Center_5,
  },
  {
    number: 6,
    self: NumbersType.Self_6,
    right: NumbersType.Right_6,
    bottom: NumbersType.Bottom_6,
    center: NumbersType.Center_6,
  },
  {
    number: 7,
    self: NumbersType.Self_7,
    right: NumbersType.Right_7,
    bottom: NumbersType.Bottom_7,
    center: NumbersType.Center_7,
  },
  {
    number: 8,
    self: NumbersType.Self_8,
    right: NumbersType.Right_8,
    bottom: NumbersType.Bottom_8,
    center: NumbersType.Center_8,
  },
  {
    number: 9,
    self: NumbersType.Self_9,
    right: NumbersType.Right_9,
    bottom: NumbersType.Bottom_9,
    center: NumbersType.Center_9,
  },
  {
    number: 10,
    self: NumbersType.Self_10,
    right: NumbersType.Right_10,
    bottom: NumbersType.Bottom_10,
    center: NumbersType.Center_10,
  },
  {
    number: 11,
    self: NumbersType.Self_11,
    right: NumbersType.Right_11,
    bottom: NumbersType.Bottom_11,
    center: NumbersType.Center_11,
  },
  {
    number: 12,
    self: NumbersType.Self_12,
    right: NumbersType.Right_12,
    bottom: NumbersType.Bottom_12,
    center: NumbersType.Center_12,
  },
  {
    number: 13,
    self: NumbersType.Self_13,
    right: NumbersType.Right_13,
    bottom: NumbersType.Bottom_13,
    center: NumbersType.Center_13,
  },
  {
    number: 14,
    self: NumbersType.Self_14,
    right: NumbersType.Right_14,
    bottom: NumbersType.Bottom_14,
    center: NumbersType.Center_14,
  },
  {
    number: 15,
    self: NumbersType.Self_15,
    right: NumbersType.Right_15,
    bottom: NumbersType.Bottom_15,
    center: NumbersType.Center_15,
  },
  {
    number: 16,
    self: NumbersType.Self_16,
    right: NumbersType.Right_16,
    bottom: NumbersType.Bottom_16,
    center: NumbersType.Center_16,
  },
  {
    number: 17,
    self: NumbersType.Self_17,
    right: NumbersType.Right_17,
    bottom: NumbersType.Bottom_17,
    center: NumbersType.Center_17,
  },
  {
    number: 18,
    self: NumbersType.Self_18,
    right: NumbersType.Right_18,
    bottom: NumbersType.Bottom_18,
    center: NumbersType.Center_18,
  },
  {
    number: 19,
    self: NumbersType.Self_19,
    right: NumbersType.Right_19,
    bottom: NumbersType.Bottom_19,
    center: NumbersType.Center_19,
  },
  {
    number: 20,
    self: NumbersType.Self_20,
    right: NumbersType.Right_20,
    bottom: NumbersType.Bottom_20,
    center: NumbersType.Center_20,
  },
  {
    number: 21,
    self: NumbersType.Self_21,
    right: NumbersType.Right_21,
    bottom: NumbersType.Bottom_21,
    center: NumbersType.Center_21,
  },
  {
    number: 22,
    self: NumbersType.Self_22,
    right: NumbersType.Right_22,
    bottom: NumbersType.Bottom_22,
    center: NumbersType.Center_22,
  },
  {
    number: 23,
    self: NumbersType.Self_23,
    right: NumbersType.Right_23,
    bottom: NumbersType.Bottom_23,
    center: NumbersType.Center_23,
  },
  {
    number: 24,
    self: NumbersType.Self_24,
    right: NumbersType.Right_24,
    bottom: NumbersType.Bottom_24,
    center: NumbersType.Center_24,
  },
  {
    number: 25,
    self: NumbersType.Self_25,
    right: NumbersType.Right_25,
    bottom: NumbersType.Bottom_25,
    center: NumbersType.Center_25,
  },
  {
    number: 26,
    self: NumbersType.Self_26,
    right: NumbersType.Right_26,
    bottom: NumbersType.Bottom_26,
    center: NumbersType.Center_26,
  },
  {
    number: 27,
    self: NumbersType.Self_27,
    right: NumbersType.Right_27,
    bottom: NumbersType.Bottom_27,
    center: NumbersType.Center_27,
  },
  {
    number: 28,
    self: NumbersType.Self_28,
    right: NumbersType.Right_28,
    bottom: NumbersType.Bottom_28,
    center: NumbersType.Center_28,
  },
  {
    number: 29,
    self: NumbersType.Self_29,
    right: NumbersType.Right_29,
    bottom: NumbersType.Bottom_29,
    center: NumbersType.Center_29,
  },
  {
    number: 30,
    self: NumbersType.Self_30,
    right: NumbersType.Right_30,
    bottom: NumbersType.Bottom_30,
    center: NumbersType.Center_30,
  },
  {
    number: 31,
    self: NumbersType.Self_31,
    right: NumbersType.Right_31,
    bottom: NumbersType.Bottom_31,
    center: NumbersType.Center_31,
  },
  {
    number: 32,
    self: NumbersType.Self_32,
    right: NumbersType.Right_32,
    bottom: NumbersType.Bottom_32,
    center: NumbersType.Center_32,
  },
  {
    number: 33,
    self: NumbersType.Self_33,
    right: NumbersType.Right_33,
    bottom: NumbersType.Bottom_33,
    center: NumbersType.Center_33,
  },
  {
    number: 34,
    self: NumbersType.Self_34,
    right: NumbersType.Right_34,
    bottom: NumbersType.Bottom_34,
    center: NumbersType.Center_34,
  },
  {
    number: 35,
    self: NumbersType.Self_35,
    right: NumbersType.Right_35,
    bottom: NumbersType.Bottom_35,
    center: NumbersType.Center_35,
  },
  {
    number: 36,
    self: NumbersType.Self_36,
    right: NumbersType.Right_36,
    bottom: NumbersType.Bottom_36,
    center: NumbersType.Center_36,
  },
  {
    number: 37,
    self: NumbersType.Self_37,
    right: NumbersType.Right_37,
    bottom: NumbersType.Bottom_37,
    center: NumbersType.Center_37,
  },
  {
    number: 38,
    self: NumbersType.Self_38,
    right: NumbersType.Right_38,
    bottom: NumbersType.Bottom_38,
    center: NumbersType.Center_38,
  },
  {
    number: 39,
    self: NumbersType.Self_39,
    right: NumbersType.Right_39,
    bottom: NumbersType.Bottom_39,
    center: NumbersType.Center_39,
  },
  {
    number: 40,
    self: NumbersType.Self_40,
    right: NumbersType.Right_40,
    bottom: NumbersType.Bottom_40,
    center: NumbersType.Center_40,
  },
];
export const KenoNumbers = new Array(KENO_NUMBERS_COUNT).fill(null).map((el, index) => index + 1);

export const IncludedNumbers = [
  {
    type: NumbersType.Self_1,
    numbers: [1],
  },
  {
    type: NumbersType.Right_1,
    numbers: [1, 2],
  },
  {
    type: NumbersType.Bottom_1,
    numbers: [1, 9],
  },
  {
    type: NumbersType.Center_1,
    numbers: [1, 2, 9, 10],
  },
  {
    type: NumbersType.Self_2,
    numbers: [2],
  },
  {
    type: NumbersType.Right_2,
    numbers: [2, 3],
  },
  {
    type: NumbersType.Bottom_2,
    numbers: [2, 10],
  },
  {
    type: NumbersType.Center_2,
    numbers: [2, 3, 10, 11],
  },
  {
    type: NumbersType.Self_3,
    numbers: [3],
  },
  {
    type: NumbersType.Right_3,
    numbers: [3, 4],
  },
  {
    type: NumbersType.Bottom_3,
    numbers: [3, 11],
  },
  {
    type: NumbersType.Center_3,
    numbers: [3, 4, 11, 12],
  },
  {
    type: NumbersType.Self_4,
    numbers: [4],
  },
  {
    type: NumbersType.Right_4,
    numbers: [4, 5],
  },
  {
    type: NumbersType.Bottom_4,
    numbers: [4, 12],
  },
  {
    type: NumbersType.Center_4,
    numbers: [4, 5, 12, 13],
  },
  {
    type: NumbersType.Self_5,
    numbers: [5],
  },
  {
    type: NumbersType.Right_5,
    numbers: [5, 6],
  },
  {
    type: NumbersType.Bottom_5,
    numbers: [5, 13],
  },
  {
    type: NumbersType.Center_5,
    numbers: [5, 6, 13, 14],
  },
  {
    type: NumbersType.Self_6,
    numbers: [6],
  },
  {
    type: NumbersType.Right_6,
    numbers: [6, 7],
  },
  {
    type: NumbersType.Bottom_6,
    numbers: [6, 14],
  },
  {
    type: NumbersType.Center_6,
    numbers: [6, 7, 14, 15],
  },
  {
    type: NumbersType.Self_7,
    numbers: [7],
  },
  {
    type: NumbersType.Right_7,
    numbers: [7, 8],
  },
  {
    type: NumbersType.Bottom_7,
    numbers: [7, 15],
  },
  {
    type: NumbersType.Center_7,
    numbers: [7, 8, 15, 16],
  },
  {
    type: NumbersType.Self_8,
    numbers: [8],
  },
  {
    type: NumbersType.Right_8,
    numbers: [],
  },
  {
    type: NumbersType.Bottom_8,
    numbers: [8, 16],
  },
  {
    type: NumbersType.Center_8,
    numbers: [],
  },
  {
    type: NumbersType.Self_9,
    numbers: [9],
  },
  {
    type: NumbersType.Right_9,
    numbers: [9, 10],
  },
  {
    type: NumbersType.Bottom_9,
    numbers: [9, 17],
  },
  {
    type: NumbersType.Center_9,
    numbers: [9, 10, 17, 18],
  },
  {
    type: NumbersType.Self_10,
    numbers: [10],
  },
  {
    type: NumbersType.Right_10,
    numbers: [10, 11],
  },
  {
    type: NumbersType.Bottom_10,
    numbers: [10, 18],
  },
  {
    type: NumbersType.Center_10,
    numbers: [10, 11, 18, 19],
  },
  {
    type: NumbersType.Self_11,
    numbers: [11],
  },
  {
    type: NumbersType.Right_11,
    numbers: [11, 12],
  },
  {
    type: NumbersType.Bottom_11,
    numbers: [11, 19],
  },
  {
    type: NumbersType.Center_11,
    numbers: [11, 12, 19, 20],
  },
  {
    type: NumbersType.Self_12,
    numbers: [12],
  },
  {
    type: NumbersType.Right_12,
    numbers: [12, 13],
  },
  {
    type: NumbersType.Bottom_12,
    numbers: [12, 20],
  },
  {
    type: NumbersType.Center_12,
    numbers: [12, 13, 20, 21],
  },
  {
    type: NumbersType.Self_13,
    numbers: [13],
  },
  {
    type: NumbersType.Right_13,
    numbers: [13, 14],
  },
  {
    type: NumbersType.Bottom_13,
    numbers: [13, 21],
  },
  {
    type: NumbersType.Center_13,
    numbers: [13, 14, 21, 22],
  },
  {
    type: NumbersType.Self_14,
    numbers: [14],
  },
  {
    type: NumbersType.Right_14,
    numbers: [14, 15],
  },
  {
    type: NumbersType.Bottom_14,
    numbers: [14, 22],
  },
  {
    type: NumbersType.Center_14,
    numbers: [14, 15, 22, 23],
  },
  {
    type: NumbersType.Self_15,
    numbers: [15],
  },
  {
    type: NumbersType.Right_15,
    numbers: [15, 16],
  },
  {
    type: NumbersType.Bottom_15,
    numbers: [15, 23],
  },
  {
    type: NumbersType.Center_15,
    numbers: [15, 16, 23, 24],
  },
  {
    type: NumbersType.Self_16,
    numbers: [16],
  },
  {
    type: NumbersType.Right_16,
    numbers: [16],
  },
  {
    type: NumbersType.Bottom_16,
    numbers: [16, 24],
  },
  {
    type: NumbersType.Center_16,
    numbers: [],
  },
  {
    type: NumbersType.Self_17,
    numbers: [17],
  },
  {
    type: NumbersType.Right_17,
    numbers: [17, 18],
  },
  {
    type: NumbersType.Bottom_17,
    numbers: [17, 25],
  },
  {
    type: NumbersType.Center_17,
    numbers: [17, 18, 25, 26],
  },
  {
    type: NumbersType.Self_18,
    numbers: [18],
  },
  {
    type: NumbersType.Right_18,
    numbers: [18, 19],
  },
  {
    type: NumbersType.Bottom_18,
    numbers: [18, 26],
  },
  {
    type: NumbersType.Center_18,
    numbers: [18, 19, 26, 27],
  },
  {
    type: NumbersType.Self_19,
    numbers: [19],
  },
  {
    type: NumbersType.Right_19,
    numbers: [19, 20],
  },
  {
    type: NumbersType.Bottom_19,
    numbers: [19, 27],
  },
  {
    type: NumbersType.Center_19,
    numbers: [19, 20, 27, 28],
  },
  {
    type: NumbersType.Self_20,
    numbers: [20],
  },
  {
    type: NumbersType.Right_20,
    numbers: [20, 21],
  },
  {
    type: NumbersType.Bottom_20,
    numbers: [20, 28],
  },
  {
    type: NumbersType.Center_20,
    numbers: [20, 21, 28, 29],
  },
  {
    type: NumbersType.Self_21,
    numbers: [21],
  },
  {
    type: NumbersType.Right_21,
    numbers: [21, 22],
  },
  {
    type: NumbersType.Bottom_21,
    numbers: [21, 29],
  },
  {
    type: NumbersType.Center_21,
    numbers: [21, 22, 29, 30],
  },
  {
    type: NumbersType.Self_22,
    numbers: [22],
  },
  {
    type: NumbersType.Right_22,
    numbers: [22, 23],
  },
  {
    type: NumbersType.Bottom_22,
    numbers: [22, 30],
  },
  {
    type: NumbersType.Center_22,
    numbers: [22, 23, 30, 31],
  },
  {
    type: NumbersType.Self_23,
    numbers: [23],
  },
  {
    type: NumbersType.Right_23,
    numbers: [23, 24],
  },
  {
    type: NumbersType.Bottom_23,
    numbers: [23, 31],
  },
  {
    type: NumbersType.Center_23,
    numbers: [23, 24, 31, 32],
  },
  {
    type: NumbersType.Self_24,
    numbers: [24],
  },
  {
    type: NumbersType.Right_24,
    numbers: [24],
  },
  {
    type: NumbersType.Bottom_24,
    numbers: [24, 32],
  },
  {
    type: NumbersType.Center_24,
    numbers: [],
  },
  {
    type: NumbersType.Self_25,
    numbers: [25],
  },
  {
    type: NumbersType.Right_25,
    numbers: [25, 26],
  },
  {
    type: NumbersType.Bottom_25,
    numbers: [25, 33],
  },
  {
    type: NumbersType.Center_25,
    numbers: [25, 26, 33, 34],
  },
  {
    type: NumbersType.Self_26,
    numbers: [26],
  },
  {
    type: NumbersType.Right_26,
    numbers: [26, 27],
  },
  {
    type: NumbersType.Bottom_26,
    numbers: [26, 34],
  },
  {
    type: NumbersType.Center_26,
    numbers: [26, 27, 34, 35],
  },
  {
    type: NumbersType.Self_27,
    numbers: [27],
  },
  {
    type: NumbersType.Right_27,
    numbers: [27, 28],
  },
  {
    type: NumbersType.Bottom_27,
    numbers: [27, 35],
  },
  {
    type: NumbersType.Center_27,
    numbers: [27, 28, 35, 36],
  },
  {
    type: NumbersType.Self_28,
    numbers: [28],
  },
  {
    type: NumbersType.Right_28,
    numbers: [28, 29],
  },
  {
    type: NumbersType.Bottom_28,
    numbers: [28, 36],
  },
  {
    type: NumbersType.Center_28,
    numbers: [28, 29, 36, 37],
  },
  {
    type: NumbersType.Self_29,
    numbers: [29],
  },
  {
    type: NumbersType.Right_29,
    numbers: [29, 30],
  },
  {
    type: NumbersType.Bottom_29,
    numbers: [29, 37],
  },
  {
    type: NumbersType.Center_29,
    numbers: [29, 30, 37, 38],
  },
  {
    type: NumbersType.Self_30,
    numbers: [30],
  },
  {
    type: NumbersType.Right_30,
    numbers: [30, 31],
  },
  {
    type: NumbersType.Bottom_30,
    numbers: [30, 38],
  },
  {
    type: NumbersType.Center_30,
    numbers: [30, 31, 38, 39],
  },
  {
    type: NumbersType.Self_31,
    numbers: [31],
  },
  {
    type: NumbersType.Right_31,
    numbers: [31, 32],
  },
  {
    type: NumbersType.Bottom_31,
    numbers: [31, 39],
  },
  {
    type: NumbersType.Center_31,
    numbers: [31, 32, 39, 40],
  },
  {
    type: NumbersType.Self_32,
    numbers: [32],
  },
  {
    type: NumbersType.Right_32,
    numbers: [32],
  },
  {
    type: NumbersType.Bottom_32,
    numbers: [32, 40],
  },
  {
    type: NumbersType.Center_32,
    numbers: [32],
  },
  {
    type: NumbersType.Self_33,
    numbers: [33],
  },
  {
    type: NumbersType.Right_33,
    numbers: [33, 34],
  },
  {
    type: NumbersType.Bottom_33,
    numbers: [33],
  },
  {
    type: NumbersType.Center_33,
    numbers: [33],
  },
  {
    type: NumbersType.Self_34,
    numbers: [34],
  },
  {
    type: NumbersType.Right_34,
    numbers: [34, 35],
  },
  {
    type: NumbersType.Bottom_34,
    numbers: [34],
  },
  {
    type: NumbersType.Center_34,
    numbers: [34],
  },
  {
    type: NumbersType.Self_35,
    numbers: [35],
  },
  {
    type: NumbersType.Right_35,
    numbers: [35, 36],
  },
  {
    type: NumbersType.Bottom_35,
    numbers: [35],
  },
  {
    type: NumbersType.Center_35,
    numbers: [35],
  },
  {
    type: NumbersType.Self_36,
    numbers: [36],
  },
  {
    type: NumbersType.Right_36,
    numbers: [36, 37],
  },
  {
    type: NumbersType.Bottom_36,
    numbers: [36],
  },
  {
    type: NumbersType.Center_36,
    numbers: [36],
  },
  {
    type: NumbersType.Self_37,
    numbers: [37],
  },
  {
    type: NumbersType.Right_37,
    numbers: [37, 38],
  },
  {
    type: NumbersType.Bottom_37,
    numbers: [37],
  },
  {
    type: NumbersType.Center_37,
    numbers: [37],
  },
  {
    type: NumbersType.Self_38,
    numbers: [38],
  },
  {
    type: NumbersType.Right_38,
    numbers: [38, 39],
  },
  {
    type: NumbersType.Bottom_38,
    numbers: [38],
  },
  {
    type: NumbersType.Center_38,
    numbers: [38],
  },
  {
    type: NumbersType.Self_39,
    numbers: [39],
  },
  {
    type: NumbersType.Right_39,
    numbers: [39, 40],
  },
  {
    type: NumbersType.Bottom_39,
    numbers: [39],
  },
  {
    type: NumbersType.Center_39,
    numbers: [39],
  },
  {
    type: NumbersType.Self_40,
    numbers: [40],
  },
  {
    type: NumbersType.Right_40,
    numbers: [40],
  },
  {
    type: NumbersType.Bottom_40,
    numbers: [40],
  },
  {
    type: NumbersType.Center_40,
    numbers: [40],
  },
];

export const KenoIncludedNumbers = IncludedNumbers.reduce((acc, current) => {
  acc[current.type] = current;
  return acc;
}, {});

export const SELECTED_NUMBERS_MAX_COUNT = 10;

export const KENO_GAME_ID = 43;

export const KenoLiveBetsColumns = [
  {
    title: TranslationKeys.UserId,
    dataKey: 'userId',
    isShow: true,
    columnType: ColumnsType.MaskNameFormat,
  },
  {
    title: TranslationKeys.Time,
    dataKey: 'date',
    columnType: ColumnsType.DateFormat,
    isShow: !isMobile(),
  },
  {
    title: isMobile() ? TranslationKeys.Bet : TranslationKeys.BetAmount,
    dataKey: 'amount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
  {
    title: TranslationKeys.Risk,
    dataKey: 'bombCount',
    isShow: !isMobile(),
    columnType: ColumnsType.Default,
    colRenderer: (spinInfo, t) => (
      <span className='cpt-table-text'>
        {t(KENO_RISK_TYPE_NAME[spinInfo.spinData?.riskType].toUpperCase())}
      </span>
    ),
  },
  {
    title: TranslationKeys.Odds,
    dataKey: 'odd',
    isShow: true,
    columnType: ColumnsType.Default,
    additionalInfoRenderer: () => 'x',
  },
  {
    title: TranslationKeys.Payout,
    dataKey: 'winAmount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
];

export const KenoBetHistoryColumns = [
  {
    title: TranslationKeys.RoundId,
    dataKey: 'id',
    isShow: true,
    columnType: ColumnsType.Default,
    colRenderer: (spinInfo) => (
      <i
        onClick={(e) => {
          e.stopPropagation();
          popupStore.open({ name: PopupTypes.Fairness, spinInfo });
          checkHashStore.setSpinInfo({
            salt: spinInfo.salt,
            key: spinInfo.key,
            hash: spinInfo.hash,
          });
        }}
        className='icon-fairness-fill cpt-table-column-icon'
      />
    ),
  },
  {
    title: TranslationKeys.Time,
    dataKey: 'date',
    columnType: ColumnsType.DateFormat,
    isShow: !isMobile(),
  },
  {
    title: isMobile() ? TranslationKeys.Bet : TranslationKeys.BetAmount,
    dataKey: 'amount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
  {
    title: TranslationKeys.Risk,
    dataKey: 'risk_type',
    colRenderer: (spinInfo, t) => (
      <span className='cpt-table-text'>
        {t(KENO_RISK_TYPE_NAME[spinInfo.riskType].toUpperCase())}
      </span>
    ),
    isShow: !isMobile(),
    columnType: ColumnsType.Default,
  },
  {
    title: TranslationKeys.Odds,
    dataKey: 'odd',
    isShow: true,
    columnType: ColumnsType.Default,
    additionalInfoRenderer: () => 'x',
  },
  {
    title: TranslationKeys.Payout,
    dataKey: 'winAmount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
];

export const KENO_RULES_KEYS = new Array(isPG() ? 20 : 12)
  .fill(null)
  .map((item, index) => index + 1);
export const KENO_ABOUT_HASH_KEYS = new Array(16).fill(null).map((item, index) => index + 1);

export const KENO_RULES_TABLE = {
  standard: [
    '',
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    1,
    '3.88x',
    '1.85x',
    '1x',
    '0.8x',
    '0.24x',
    '0x',
    '0x',
    '0x',
    '0x',
    '0x',
    2,
    '',
    '4.48x',
    '3.05x',
    '1.72x',
    '1.38x',
    '1x',
    '0.45x',
    '0x',
    '0x',
    '0x',
    3,
    '',
    '',
    '9.35x',
    '4.95x',
    '4x',
    '3.57x',
    '2.95x',
    '2.15x',
    '1.5x',
    '1.37x',
    4,
    '',
    '',
    '',
    '22.3x',
    '16.3x',
    '6.8x',
    '4.44x',
    '3.9x',
    '2.95x',
    '2.2x',
    5,
    '',
    '',
    '',
    '',
    '35.5x',
    '16.2x',
    '13.85x',
    '12.9x',
    '7.96x',
    '4.45x',
    6,
    '',
    '',
    '',
    '',
    '',
    '37x',
    '30x',
    '21.9x',
    '14.96x',
    '7.7x',
    7,
    '',
    '',
    '',
    '',
    '',
    '',
    '60x',
    '55x',
    '44x',
    '16.7x',
    8,
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '70x',
    '60x',
    '50x',
    9,
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '85x',
    '80x',
    10,
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    'x100',
  ],
  low: [
    'TABLE_INFO',
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    0,
    '0.68x',
    '0x',
    '0x',
    '0x',
    '0x',
    '0x',
    '0x',
    '0x',
    '0x',
    '0x',
    1,
    '1.84x',
    '1.96x',
    '1.07x',
    '0x',
    '0x',
    '0x',
    '0x',
    '0x',
    '0x',
    '0x',
    2,
    '',
    '3.75x',
    '1.37x',
    '2.15x',
    '1.48x',
    '1.06x',
    '1.07x',
    '1.08x',
    '1.05x',
    '1.08x',
    3,
    '',
    '',
    '25.7x',
    '7.86x',
    '4.1x',
    '1.96x',
    '1.57x',
    '1.45x',
    '1.29x',
    '1.18x',
    4,
    '',
    '',
    '',
    '87x',
    '12.43x',
    '6.16x',
    '3.47x',
    '1.98x',
    '1.69x',
    '1.28x',
    5,
    '',
    '',
    '',
    '',
    'x300',
    '99x',
    '14.57x',
    '5.48x',
    '2.49x',
    '1.76x',
    6,
    '',
    '',
    '',
    '',
    '',
    '700x',
    '225x',
    '38.8x',
    '7.49x',
    '3.4x',
    7,
    '',
    '',
    '',
    '',
    '',
    '',
    '700x',
    'x100',
    '49x',
    '12.9x',
    8,
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '800x',
    '250x',
    '50x',
    9,
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '1Kx',
    '250x',
    10,
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '1Kx',
  ],
  medium: [
    'TABLE_INFO',
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    0,
    '0.38x',
    '0x',
    '0x',
    '0x',
    '0x',
    '0x',
    '0x',
    '0x',
    '0x',
    '0x',
    1,
    '2.74x',
    '1.77x',
    '0x',
    '0x',
    '0x',
    '0x',
    '0x',
    '0x',
    '0x',
    '0x',
    2,
    '',
    '5x',
    '2.74x',
    '1.67x',
    '1.35x',
    '0x',
    '0x',
    '0x',
    '0x',
    '0x',
    3,
    '',
    '',
    '49x',
    '9.7x',
    '3.96x',
    '2.9x',
    '1.95x',
    '1.95x',
    '1.95x',
    '1.57x',
    4,
    '',
    '',
    '',
    'x100',
    '13.8x',
    '8.9x',
    '6.8x',
    '3.96x',
    '2.47x',
    '1.95x',
    5,
    '',
    '',
    '',
    '',
    '389x',
    '178x',
    '29.8x',
    '10.6x',
    '4.9x',
    '3.96x',
    6,
    '',
    '',
    '',
    '',
    '',
    '709x',
    'x400',
    '66.9x',
    '14.9x',
    '6.9x',
    7,
    '',
    '',
    '',
    '',
    '',
    '',
    '800x',
    '396x',
    '99x',
    '25.5x',
    8,
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '896x',
    '500x',
    'x100',
    9,
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '1Kx',
    '250x',
    10,
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '1Kx',
  ],
  high: [
    'TABLE_INFO',
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    1,
    '3.88x',
    '0x',
    '0x',
    '0x',
    '0x',
    '0x',
    '0x',
    '0x',
    '0x',
    '0x',
    2,
    '',
    '16.82x',
    '0x',
    '0x',
    '0x',
    '0x',
    '0x',
    '0x',
    '0x',
    '0x',
    3,
    '',
    '',
    '79.9x',
    '9.7x',
    '4.4x',
    '0x',
    '0x',
    '0x',
    '0x',
    '0x',
    4,
    '',
    '',
    '',
    '256x',
    '47x',
    '10.4x',
    '6.8x',
    '4.9x',
    '3.96x',
    '3.43x',
    5,
    '',
    '',
    '',
    '',
    '444x',
    '347x',
    '88.2x',
    '19.2x',
    '10.5x',
    '7.9x',
    6,
    '',
    '',
    '',
    '',
    '',
    '709x',
    'x400',
    '269x',
    '55x',
    '12.5x',
    7,
    '',
    '',
    '',
    '',
    '',
    '',
    '800x',
    '599x',
    '500x',
    '60x',
    8,
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '896x',
    '800x',
    '500x',
    9,
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '1Kx',
    '800x',
    10,
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '1Kx',
  ],
};
